import { createContext } from 'react';

export interface PersonaImport {
  acceptedTerms: boolean;
  uploadStatus:
    | 'idle'
    | 'selecting'
    | 'uploading'
    | 'completed'
    | 'finalizing'
    | 'error'
    | 'incomplete';
  personaImportId?: string;
  name?: string;
  otherParticipantName?: string;
  relationship?: string;
}

type PersonaImportContextProps = {
  personaImport: PersonaImport;
  updatePersonaImport: (props: Partial<PersonaImport>) => void;
  onNext: () => void;
  reset: () => void;
};

export const PersonaImportContext = createContext<PersonaImportContextProps>({
  personaImport: { acceptedTerms: false, uploadStatus: 'idle' },
  updatePersonaImport: () => {},
  onNext: () => {},
  reset: () => {}
});
